import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getContractor = async (param) => {
    try {
  return await get<ApiResponse<[]>>(`/contractor?${param}`).then((res)=> {
        if(res.success===true) {
                return res
        }
        else {
            return null
        }
  })
}
catch(e) {
    HandleApiError(e)
}
};
